import { createContext } from 'react';

import {
  CapabilityApplications,
  ReportId,
  Sponsor,
  VectilesMetricIds,
} from '@hcs/types';

export interface PlatformSearchNavArgs {
  activePropertySlug?: string;
  placeId?: string;
  buyBoxId?: number;
  mapLayer?: VectilesMetricIds;
  coordinates?: {
    latitude: number;
    longitude: number;
    zoom?: number;
  };
  contentView?: 'Property Search' | 'Market Insights';
}

export interface NavigationContextValue {
  apiKeysLink?: string;
  apiExplorerLink?: string;
  canaryAiLink?: string;
  dataExplorerLink?: string;
  dataExplorerPreviousAnalysesLink?: string;
  marketInsightsLink?: string;
  usageReportLink?: string;
  billingDashboardLink?: string;
  changePlanLink?: string;
  orderManagerLink?: string;
  listingsDashboardLink?: string;
  checkoutSuccessUrl?: string;
  selectPlanLink?: string;
  agentSelectPlanLink?: string;
  agentConfirmEmailLink?: string;
  agentCheckoutLink?: string;
  agentVerifyConfirmLink?: string;
  makeSponsorLandingLink?: (sponsor: Sponsor) => string;
  makePexpPropertyLink?: (slugOrAddressId: string | number) => string;
  makePexpReportLink?: (reportId: ReportId, isRental?: boolean) => string;
  makeOrderLink?: (orderId: number) => string;
  makeZipcodeInsightsLink?: (zipcode: string) => string;
  makeMsaInsightsLink?: (msaId: string) => string;
  makeCityInsightsLink?: (placeId: string) => string;
  makeBuyBoxLink?: (buyBoxId: number) => string;
  makeProductDetailsLink?: (applicationKey: CapabilityApplications) => string;
  makePlatformSearchLink?: (args?: PlatformSearchNavArgs | null) => string;
}

export const NavigationContext = createContext<NavigationContextValue>({});
